/**
 * 单个视频播放
 */
import React, {Component} from 'react';
import notification from 'c-notification';
import WebChat from '../webchat/index';
import StopLive from '../view/exception/livend';
import Timeout from '../view/exception/timeout';
import Flv from "../../component/video/flv";
import lang from '../../lang/index';
import queueanim from '../queueanim';
import voiceCfg from '../queueanim/voice';

class VideoLayer extends Component {
    static defaultProps = {
        roomid: '',
        hostid: '',
        avatar: '',
        videoid: '',
        onlyView: 1
    }

	constructor(props) {
        super(props);

        this.state = {
            liveMsg: {}, // 直播流地址
            roomid: props.roomid,
            hostid: props.hostid, // 主播uid
            hostAvatar: props.avatar, // 主播头像
            enterRoomSuccess: false,  // 是否成功进入直播间
            hostStopLive: null, // 主播是否停止直播
            enterRoomTimeout: null, // 进入房间是否超时
            loading: true,
            showButton: false,
            voiceFlag: false
        };
	}
    // componentWillReceiveProps(nextProps) {
    //     this.setState({
    //         hostid: nextProps.hostid,
    //         roomid: nextProps.roomid,
    //         avatar: nextProps.avatar                
    //     }, ()=> {
    //         this.play();
    //     });
    // }

    play = (e) => {
        this.setState({
            loading: true
        });
    
        this.createVideo();
    }


	// 成功进入房间
    onEnterRoomSuccess(resp) {
        this.setState({
            liveMsg: JSON.parse(resp.liveMsg),
            voiceFlag: resp.voiceFlag,
            enterRoomSuccess: true,
            enterRoomTimeout: false,
            hostStopLive: false
        }, ()=>{
            this.play();
            this.bindEvent();
        });
    }

    bindEvent(){
        let nodeWrap = $(this.refs.wrap);
        
        nodeWrap.on('mouseover', '.vcp-controls-panel', (e)=>{
            this.hideTimer && clearTimeout(this.hideTimer);
        });

        nodeWrap.on('mouseover', '.vjs-controls', (e)=>{
            this.hideTimer && clearTimeout(this.hideTimer);
        });

        nodeWrap.on('mouseover', '.btn-enter', (e)=>{
            this.hideTimer && clearTimeout(this.hideTimer);
        });
    }

    onEnterRoomFail(code) {
        let self = this;
        let tip;
        
        switch(code) {
            // 主播停播
            case 20482:
                this.setState({
                    hostStopLive: true,
                    enterRoomSuccess: false,
                    enterRoomTimeout: false
                });
                break;
            // 被踢出
            case 20490:
                tip = lang.template('您已被移出直播间，请稍后再试');
                notification.simple(tip);
                break;
            case 4096:
                tip = lang.template('参数错误');
                notification.simple(tip);
                break;
            case 8192:
                $.channel.emit('login')
                return;
            default:
                tip = lang.template('系统错误');
                notification.simple(tip);
                break;
        }
    }

    onEnterRoomTimeout() {
        this.setState({
            enterRoomTimeout: true,
            enterRoomSuccess: false,
            hostStopLive: false
        });
    }

    createVideo() {
        let self = this;
        let { liveMsg } = this.state;

        if (!liveMsg.flv) {
            return;
        }

        var flv = (this.flv = new Flv({
            wrap: $(".J_VideoWrap", $(this.refs.wrap)),
            source: liveMsg.flv,
            id: this.props.videoid
        }));
        
        flv.on("start", (player) => {

            this.setState({
                videoPlaying: true                
            });

            setTimeout(() => {
                this.setState({
                    loading: false
                }, function(){
                    $(self.refs.videomask).removeClass('hidden');
                    $(self.refs.poster).remove();
                    this.onPlayStart();
                });
            }, 2 * 1000);
        });

        flv.on('fullscreen', ()=>{
            this.setState({
                showButton: false
            });
        })

        flv.play();

        // 如果10s后视频没有播放，则判断为浏览器flash插件不可用
        this.__timer = setTimeout(()=>{
            if (!this.state.videoPlaying) {
                this.setState({
                    loading: false
                }, function(){
                    $(self.refs.poster).remove();
                    $(self.refs.videomask).addClass('hidden');
                    $(self.refs.videoWrap).addClass('no-flash');
                });
            }
        }, 10 * 1000);
    }

    componentWillUnmount() {
        this.flv && this.flv.destroy();
        this.__timer && clearTimeout(this.__timer);
        this.hideTimer && clearTimeout(this.hideTimer);
    }

    onMouseOver=(e)=>{

        if (this.flv) {
            this.flv.showControlBar();
        }

        this.setState({
            showButton: true
        });

        this.hideTimer && clearTimeout(this.hideTimer);
    }

    onMouseOut=(e)=>{
        this.hideTimer = setTimeout(()=>{
            if (this.flv) {
                this.flv.hideControlBar();
            }

            this.setState({
                showButton: false
            });
        }, 1 * 1000);
    }

    reconnectRoom() {
        this.refs.webchat.webchat.reinit()
    }

    goRoom=(e)=> {
        hashHistory.push("living/" + this.state.hostid + '/' + this.state.roomid);
    }

    onPlayStart(){
        let node = $('.J_UpVoiceWrap');
        
        if (node.length > 0) {
            // if (UP.Global.isSafari) {
                node.remove();
                $('#J_VideoMini .vjs-controls').before($('<div class="video-voicebg" node-id="voice"></div>'));
                queueanim.play($('#J_VideoMini [node-id="voice"]') , voiceCfg.jsons, voiceCfg.mergePics);
            // } else {
            //     $(this.refs.videoWrap).addClass('upvoice');
            //     queueanim.play(node , voiceCfg.jsons, voiceCfg.mergePics);
            // }
        }
    }

	render() {
        let {  hostStopLive, enterRoomTimeout, enterRoomSuccess } = this.state;
		let $liveDom;

		if (enterRoomSuccess) {
            $liveDom = (
                <div> 
                    <div className="video-wrap J_VideoWrap" id="J_VideoMini" ref="videoWrap">
                        { 
                            this.state.voiceFlag ? <div className="video-voicebg J_UpVoiceWrap" onMouseOver={this.onMouseOver} onMouseOut={this.onMouseOut}></div> : null 
                        }
                        <div ref="videomask" className="video-mask" onMouseOver={this.onMouseOver} onMouseOut={this.onMouseOut}>
                            { this.state.showButton ? <button className="enter btn-enter" onClick={this.goRoom}>{lang.template('进入直播间')}</button> : null }
                        </div>
                    </div>
                    <div className="poster" ref="poster">
                        <div
                            className="posterpic"
                            ref="avatar"
                            style={{ backgroundImage: `url(${this.state.hostAvatar})` }}
                        />
                        { this.state.loading ? <div className="liveroom-three-bounce"><div className="one"></div><div className="two"></div><div className="three"></div></div> : null}
                    </div>
                </div>
            );
        } else if (hostStopLive) {
            $liveDom = <StopLive roomId={this.state.roomid}/>;
        } else if (enterRoomTimeout) {
            $liveDom = <Timeout reconnectRoom={this.reconnectRoom.bind(this)} />;
        }

		return (
			<div className="videoplay" ref="wrap">
                { $liveDom }
				<WebChat
	                {...this.props} 
                    roomid={this.state.roomid}
	                onEnterRoomSuccess={(resp)=>this.onEnterRoomSuccess(resp)}
	                onEnterRoomFail={this.onEnterRoomFail.bind(this)}
	                onEnterRoomTimeout={this.onEnterRoomTimeout.bind(this)}                
	                ref="webchat"
	            />
            </div>
		);
	}
}

export default VideoLayer;


// WEBPACK FOOTER //
// ./js/living/videolayer/index.js